<template>
  <v-container
    id="extrado-clientes-faturado-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="4"
                md="4"
                lg="4"
              >
                <div class="text-right" />
              </v-col>
              <v-col
                id="selectEmpresa"
                cols="12"
                sm="8"
                md="8"
                lg="8"
              >
                <v-select
                  v-model="selectCliente"
                  :items="filterClientes.length > 0 ? filterClientes : clientes"
                  item-value="id"
                  item-text="cliente"
                  label="Clientes"
                  multiple
                  return-object
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.cliente }}, </span>
                    </v-chip>
                    <v-chip v-if="index === 1">
                      <span>{{ item.cliente }}, </span>
                    </v-chip>
                    <v-chip v-if="index === 2">
                      <span>{{ item.cliente }}, </span>
                    </v-chip>
                    <v-chip v-if="index === 3">
                      <span>{{ item.cliente }}</span>
                    </v-chip>
                    <span
                      v-if="index === 4"
                      class="grey--text text-caption"
                    >
                      (+{{ selectCliente.length - 4 }} outros)
                    </span>
                  </template>
                  <template v-slot>
                    selecione um cliente
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-action>
                        <input
                          id="filtroCliente"
                          v-model="filtro"
                          prepend-inner-icon="mdi-account-search"
                          placeholder="Filtrar Clientes"
                          @change="filter"
                        >
                      </v-list-item-action>
                      <v-divider
                        slot="prepend-item"
                        class="mt-2"
                      /><br>
                    </v-list-item>
                    <v-list-item
                      slot="prepend-item"
                      ripple
                      @click="toggle"
                    >
                      <v-list-item-action>
                        <v-icon :color="selectCliente.length > 0 ? 'indigo darken-4' : ''">
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-title id="idSelecTotos">
                        Selecionar todos
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider
                      slot="prepend-item"
                      class="mt-2"
                    />
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <div v-if="selectCliente.length <= 0">
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <div
                    class="text-center"
                  >
                    <v-icon
                      id="iconFilter"
                    >
                      mdi-filter-remove-outline
                    </v-icon>
                    <div id="atencao">
                      Atenção
                    </div>
                    <div id="textoAtencao">
                      É necessário a seleção de algum cliente para liberar o painel.
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div
              v-else
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <dashboard-filtro-datas
                    :primeiro="enablePrimeiroDia"
                    :ultimo="enableUltimoDia"
                    :empresas="enableEmpresa"
                    :vendedores="enableVendedor"
                    :supervisores="enableSupervisor"
                    :receitas="enableReceita"
                    :segmentos="enableSegmento"
                    :url="link"
                  />
                </v-col>
              </v-row>
            </div>
            <v-row v-if="enableConsulta">
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-row>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Qual o faturamento do cliente?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('252')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '252'"
                                v-html="textoFatCliente"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <show-dados-extrato-faturamento-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Qual a participação do cliente ao longo do tempo?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('253')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '253'"
                                v-html="textoPartCliente"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <dashboard-comparativo-evolucao-faturamento-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            E a quantidade vendida?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('254')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '254'"
                                v-html="textoQuantCliente"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <show-dados-quantidade-extrato-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row><br>
                <v-row>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Qual o seu ticket médio?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('255')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '255'"
                                v-html="textoTicketMedio"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <show-dados-ticket-medio-extrato-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="8"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            E o desempenho do cliente nos últimos 6 meses?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('256')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '256'"
                                v-html="textoDesempenho"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <dashboard-evolucao-semestral-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row><br>
                <v-row>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            E qual o seu MIX comercializado?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('257')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '257'"
                                v-html="textoMixComercializado"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <show-dados-mix-comercializado />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="8"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Qual o perfil do MIX comprado?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('258')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '258'"
                                v-html="textoPerfilMixComprado"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <show-table-mix-comprado-extrato-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row><br>
                <v-row>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Qual foi o total devolvido?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('259')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '259'"
                                v-html="textoDevolvido"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <show-dados-devolucao-cliente />
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Quais grupos de produtos vender?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('260')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '260'"
                                v-html="textoProdutosVender"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <br><br>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            id="componenteExtratoCliente"
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <v-row v-if="loading">
                              <div
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                            </v-row>
                            <v-row v-else-if="error">
                              <div
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                            </v-row>
                            <v-row v-else>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                              >
                                <div
                                  id="idTable"
                                  style="overflow-x: auto; max-width: 100%;"
                                >
                                  <table
                                    style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                                    class="elevation-1"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Linha de produto
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Status
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in produtoVender"
                                        :key="item.id"
                                      >
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.grupo_produto }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.status }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <router-link
                                  to="/somenteclientes/detalhe-produtos-vender"
                                  :style="styleObject"
                                >
                                  <div
                                    class="text-center"
                                  >
                                    <v-icon
                                      class="text-center"
                                    >
                                      mdi-chevron-double-down
                                    </v-icon><br>
                                  </div>
                                </router-link>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col
                    id="componenteExtratoCliente"
                    cols="12"
                    sm="12"
                    md="12"
                    lg="4"
                  >
                    <v-card
                      id="cardDashbord"
                      class="mx-auto"
                      outlined
                    >
                      <div class="card-header-dashbord">
                        <v-row>
                          <v-col
                            cols="12"
                            sm="10"
                            md="10"
                            lg="10"
                            class="d-flex flex-wrap"
                          >
                            Quais produtos focar?
                          </v-col>
                          <v-col
                            cols="12"
                            sm="2"
                            md="2"
                            lg="2"
                            class="d-flex justify-end"
                          >
                            <v-tooltip top>
                              <template
                                v-slot:activator="{ on, attrs }"
                              >
                                <v-icon
                                  id="iconInformationClientesParcipantes"
                                  class="text-left"
                                  v-bind="attrs"
                                  v-on="on"
                                  @mouseover="enableTexto('261')"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <div
                                v-if="codigo === '261'"
                                v-html="textoProdutosFocar"
                              />
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </div>
                      <v-card-actions>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                          >
                            <v-row v-if="loading">
                              <div
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                            </v-row>
                            <v-row v-else-if="error">
                              <div
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                            </v-row>
                            <v-row v-else>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                              >
                                <div
                                  id="idTable"
                                  style="overflow-x: auto; max-width: 100%;"
                                >
                                  <table
                                    style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                                    class="elevation-1"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Produto
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Status
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Faturamento gerado
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in produtoFocar"
                                        :key="item.id"
                                      >
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.produto }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.status }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: left;"
                                        >
                                          {{ item.faturamento }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <router-link
                                  to="/somenteclientes/detalhe-produtos-focar"
                                  :style="styleObject"
                                >
                                  <div
                                    class="text-center"
                                  >
                                    <v-icon
                                      class="text-center"
                                    >
                                      mdi-chevron-double-down
                                    </v-icon><br>
                                  </div>
                                </router-link>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Cliente from '../../../../../services/somentecliente'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardExtratoCliente',
    emits: ['setComparativoEvolucaoCliente', 'atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      ShowDadosExtratoFaturamentoCliente: () => import('../../../components/comercial/somenteClientes/extratoClientes/ExtratoClientesDadosFaturamento'),
      ShowDadosQuantidadeExtratoCliente: () => import('../../../components/comercial/somenteClientes/extratoClientes/ExtratoClientesDadosQuantidade'),
      DashboardComparativoEvolucaoFaturamentoCliente: () => import('../../../graficos/SomenteClientes/ExtratoCliente/ClientesComparativoEvolucaoFaturamento'),
      DashboardEvolucaoSemestralCliente: () => import('../../../graficos/SomenteClientes/ExtratoCliente/ClientesEvolucaoTicketMensalCliente'),
      ShowDadosTicketMedioExtratoCliente: () => import('../../../components/comercial/somenteClientes/extratoClientes/ExtratoClientesDadosTicketMedio'),
      ShowDadosMixComercializado: () => import('../../../components/comercial/somenteClientes/extratoClientes/ExtratoClientesDadosMixComercializado'),
      ShowTableMixCompradoExtratoCliente: () => import('../../../components/comercial/somenteClientes/extratoClientes/ExtratoClientesTableMixComercializado'),
      ShowDadosDevolucaoCliente: () => import('../../../components/comercial/somenteClientes/extratoClientes/ExtratoClientesDadosDevolucao'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      filterClientes: [],
      filtro: '',
      paginaEnable: false,
      enableConsulta: false,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      receita: [],
      segmento: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      link: localStorage.linkClientes,
      clientes: [],
      selectCliente: [],
      produtoVender: [],
      produtoFocar: [],
      vendedoresSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      categoria: [],
      promotor: [],
      codigo: 0,
      orientacao: [],
      textoFatCliente: '',
      textoPartCliente: '',
      textoQuantCliente: '',
      textoTicketMedio: '',
      textoDesempenho: '',
      textoMixComercializado: '',
      textoPerfilMixComprado: '',
      textoDevolvido: '',
      textoProdutosVender: '',
      textoProdutosFocar: '',
      headersProdutosVender: [
        { text: 'Linha de produto', value: 'grupo_produto', width: '200', class: 'black--text title' },
        { text: 'Status', value: 'status', width: '120px', class: 'black--text title' },
      ],
      headersProdutoFocar: [
        { text: 'Produto', value: 'produto', width: '100px', class: 'black--text title' },
        { text: 'Status', value: 'status', width: '120px', class: 'black--text title' },
        { text: 'Faturamento gerado', value: 'faturamento', width: '120px', align: 'right', class: 'black--text title' },
      ],
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    computed: {
      likesAllCliente () {
        return this.selectCliente.length === this.clientes.length
      },
      likesSomeCliente () {
        return this.selectCliente.length > 0 && !this.likesAllCliente
      },
      icon () {
        if (this.likesAllCliente) return 'mdi-close-box'
        if (this.likesSomeCliente) return 'mdi-minus-box'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.enableConsulta = false
        return 'mdi-checkbox-blank-outline'
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Extrato Clientes')

        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoCliente'))

        Cliente.showDadosCliente(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.dadosClientes.length; i++) {
              this.clientes.push(resposta.data.dadosClientes[i])
            }
          } else if (resposta.data.msg === 'Não há clientes cadastrados') {
            this.clientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedoresSelect = vendedores
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.updateDate()
      },

      toggle () {
        this.$nextTick(() => {
          if (this.likesAllCliente) {
            this.selectCliente = []
          } else {
            if (this.filterClientes.length > 0) {
              this.selectCliente = this.filterClientes
            } else {
              this.selectCliente = this.clientes.slice()
            }
          }
        })
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '252') {
            this.textoFatCliente = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '253') {
            this.textoPartCliente = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '254') {
            this.textoQuantCliente = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '255') {
            this.textoTicketMedio = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '256') {
            this.textoDesempenho = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '257') {
            this.textoMixComercializado = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '258') {
            this.textoPerfilMixComprado = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '259') {
            this.textoDevolvido = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '260') {
            this.textoProdutosVender = this.orientacao[i].descricao
          } else if (this.orientacao[i].codigo === '261') {
            this.textoProdutosFocar = this.orientacao[i].descricao
          }
        }
      },

      updateDate () {
        this.enableConsulta = true

        this.produtoVender = []
        this.produtoFocar = []

        this.showDadosProdutoVenderEFocar()

        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaSelect', JSON.stringify(this.select))
        localStorage.setItem('clienteSelect', JSON.stringify(this.selectCliente))
        localStorage.setItem('vendedoresId', JSON.stringify(this.vendedoresSelect))

        eventEmit.$emit('set-comparativo-evolucao-cliente', this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedoresSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor)
      },

      filter () {
        if (this.filtro.length > 0) {
          for (let i = 0; i < this.clientes.length; i++) {
            if (this.clientes[i].cliente.toLowerCase().includes(this.filtro.toLowerCase())) {
              this.filterClientes.push(this.clientes[i])
            }
          }
        } else {
          this.filterClientes = []
        }
      },

      async showDadosProdutoVenderEFocar () {
        this.loading = true

        await Cliente.showClientesProdutoVenderEFocar(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedoresSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.produtoVender = resposta.data.produtosVender

            this.produtoFocar = resposta.data.produtosFocar.map((item) => {
              var listaProdutoFocar = ({
                produto: item.produto,
                status: item.status,
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaProdutoFocar
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #componenteExtratoCliente {
      margin: -2rem 0 0 0 !important
    }

    #listItemFaturamentoClientes {
      padding-right: 6rem !important
    }

    #listItemFaturamentoClientesParticipacao {
      padding-right: 6rem !important
    }

    #listItemFaturamentoClientesDesempenho {
      padding-right: 6rem !important
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1001px)
  and (max-width : 1280px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1601px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #listItemFaturamentoClientes {
      padding-right: 21rem !important
    }

    #listItemFaturamentoClientesParticipacao {
      padding-right: 16rem !important
    }

    #listItemFaturamentoClientesDesempenho{
      padding-right: 61rem !important
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }
</style>

<style lang="sass">
  #idSelecTotos
    margin: 0 0 0 1rem

  #iconFilter
    font-size: 35px
    font-weight: bold
    color: red

  #atencao
    font-size: 50px
    font-weight: bold

  #iconFilter
    font-size: 28px

  #valorFaturamentoCliente
    font-size: 32px
    font-weight: bold
    color: #4780b8

  #valorFaturamentoClienteAnterior
    font-size: 24px
    font-weight: bold
    color: #4780b8

  #filtroCliente
    width: 97%
    border-style: groove
    background-color: ghostwhite
    margin: 0 1rem 0 1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFaturamentoClientes
    padding-right: 8rem !important
    margin: -2rem 0 0 -1rem

  #listItemFaturamentoClientesParticipacao
    padding-right: 3rem !important
    margin: -2rem 0 0 -1rem

  #listItemFaturamentoClientesDesempenho
    padding-right: 33.5rem !important
    margin: -2rem 0 0 -1rem

  #componenteExtratoCliente
    margin: -3rem 0 0 0

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
